import { Component, ElementRef, inject, ViewChild } from "@angular/core";
import { CallWithChatAdapterService } from "live-lesson/shared/chat/data-access";
import App from "../react/App";
import { AsyncPipe } from "@angular/common";
import { SlidePreviewComponent } from 'shared/classroom/preview-screen/feature-shell';
import { RenderReactDirective } from 'shared/angular-react';

@Component({
    selector: 'app-rooms',
    templateUrl: './rooms.component.html',
    styleUrls: ['./rooms.component.scss'],
    providers: [CallWithChatAdapterService],
    imports: [SlidePreviewComponent, RenderReactDirective, AsyncPipe]
})
export class RoomsComponent {
    private readonly callWithChatAdapterService = inject(CallWithChatAdapterService);

    readonly callWithChatProps$ = this.callWithChatAdapterService.callAndChatAdapter$;
    readonly isConnectedToCall$ = this.callWithChatAdapterService.isConnectedToCall$;

    @ViewChild('activeElement') set activeElementElement(el: ElementRef<HTMLElement> | null) {
        this.callWithChatAdapterService.setActiveElementElement(el?.nativeElement ?? null);
    }

    protected readonly App = App;
}
